import type { ModalOptions } from '../types';

export const getAverageAmount = (
	ppmuAverageAmountExperiment: ModalOptions['ppmuAverageAmountExperiment'],
): number | undefined => {
	if (!ppmuAverageAmountExperiment) return undefined;
	const {
		experiment: { variation },
		featureConfig,
	} = ppmuAverageAmountExperiment;
	if (variation === 'control' || variation === 'fake_control') return undefined;
	return featureConfig?.averageAmount;
};

export const getAverageAmountExperimentVariant = (
	ppmuAverageAmountExperiment: ModalOptions['ppmuAverageAmountExperiment'],
): NonNullable<ModalOptions['ppmuAverageAmountExperiment']>['experiment']['variation'] => {
	if (!ppmuAverageAmountExperiment) return 'control';
	const {
		experiment: { variation },
	} = ppmuAverageAmountExperiment;
	return variation;
};
